import React from 'react';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';

interface ImagesHeaderProps {
  imagesCount: number;
  onAddClick: () => void;
}

const ImagesHeader = ({ imagesCount, onAddClick }: ImagesHeaderProps) => {
  const handleAddClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onAddClick();
  };

  // Show the add button as long as we're under the max count
  const showAddButton = imagesCount < 20;

  return (
    <div className="flex items-center justify-between">
      <Label>Project Images (Max 20)</Label>
    </div>
  );
};

export default ImagesHeader;
